import script from "./ContentblockTwoLocations.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentblockTwoLocations.vue?vue&type=script&setup=true&lang=js"

import "./ContentblockTwoLocations.vue?vue&type=style&index=0&id=6c0c28ac&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c0c28ac"]])

export default __exports__